'use strict';
import { react2angular } from 'react2angular';
import LegacyErrorNotification from "../../src/components/Notifications/LegacyErrorNotification";

angular
    .module('dstreamApp.reactBridge')
    .component('dsLegacyErrorNotification', react2angular(LegacyErrorNotification, ['message', 'inTable']));
